import Model from '@ember-data/model';

import { attr, belongsTo, hasMany } from '@ember-data/model';

export default class ModelRunModel extends Model {
  @attr('string') ensembleName;
  @attr('string') ensembleDescription;
  @attr('string') title;
  @attr('string') description;
  @attr('string') modelRunSourceName;
  @attr('string') modelRunSourceCode;
  @attr modelRunAttributes;
  @attr('string') sourceCode;
  @attr('date') modelRunDateTime;
  @attr('date') createDate;
  @attr('date') updateDate;
  @attr('date') temporalStartDate;
  @attr('date') temporalEndDate;

  @belongsTo('item', { async: true, inverse: 'modelRuns' }) item;
  @hasMany('model-run-member', { async: true, inverse: 'modelRun' }) modelRunMembers;
}
